export default function getDateKeyInTimeZone(
  date: Date,
  timeZone: string,
): string {
  const effectiveTimeZone = getValidTimeZone(timeZone);

  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: effectiveTimeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const part = (type: string): string =>
    parts.find((value) => value.type === type)?.value || '';

  return `${part('year')}-${part('month')}-${part('day')}`;
}

export function getValidTimeZone(timeZone?: string): string {
  try {
    if (timeZone) {
      new Intl.DateTimeFormat('en-US', { timeZone }).format(new Date(0));
      return timeZone;
    }
  } catch {
    // Fall through to the documented default for invalid company timezones.
  }

  return 'America/Sao_Paulo';
}

export function getCompanyMonthRange(date: Date, timeZone: string): [string, string] {
  const currentDate = getDateKeyInTimeZone(date, timeZone);
  const monthStart = `${currentDate.slice(0, 7)}-01`;
  const [year, month] = currentDate.slice(0, 7).split('-').map(Number);
  const lastDay = new Date(Date.UTC(year, month, 0));
  const monthEnd = `${lastDay.getUTCFullYear()}-${String(
    lastDay.getUTCMonth() + 1,
  ).padStart(2, '0')}-${String(lastDay.getUTCDate()).padStart(2, '0')}`;

  return [monthStart, monthEnd];
}
